import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    minWidth: '780px',
    maxWidth: '1000px',
    borderRadius: 16,
    backgroundColor: '#FAFCFF',
  },
}));

export const StyledbBoxContainer = styled(Box)(() => ({
  minWidth: 700,
  minHeight: 200,
  padding: '40px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
}));

export const TitleBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
}));

export const StyledTypography = styled(Typography)(() => ({
  padding: '8px',
  fontSize: '14px',
  lineHeight: '32px',
  width: '80%',
  cursor: 'pointer',
}));

export const Title = styled(Typography)(() => ({
  color: '#707070',
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '22px',
  padding: '10px',
}));

export const ScrollableGrid = styled(Grid)(() => ({
  minHeight: '180px',
  borderRadius: '6px',
  width: '100%',
  overflowY: 'auto',
  margin: '0px auto',
  padding: '16px 8px',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.secondary.main,
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
  margin: '-8px -8px 0 0',
}));
